import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptionsArgs, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/empty';

import { CacheService } from './cache.service';
import { NodeLoggerService } from './node-logger.service';
import { CookieService } from './cookie';

const responseStatuses = {
  noContent: 204,
  authRequired: 401
};

@Injectable()
export class ApiService {

  clientSideCaching: boolean = true;

  constructor(private http: Http,
    private cache: CacheService,
    private nodeLogger: NodeLoggerService,
    @Inject('isBrowser') private isBrowser: boolean,
    @Inject('CookieService') private cookie: CookieService) {
  }

  /**
   * whatever domain/feature method name
   */
  get(url: string, options?: RequestOptionsArgs): Observable<any> {

    if (this.clientSideCaching == false) {
      if (this.isBrowser && this.cache.has(url)) {
        let obs = Observable.of(this.cache.get(url));
        this.cache.clear(url);
        return obs;
      }
      options = this.createAuthorizationHeader(options);
      return this.http
        .get(url, options)
        .map(ApiService.extractData)
        .do(json => {
          if (!this.isBrowser) {
            this.cache.set(url, json);
          }
        })
        .catch((err: any) => this.handleError(err));
    }
    else {

      if (this.cache.has(url)) {
        let obs = Observable.of(this.cache.get(url));
        return obs;
      }
      options = this.createAuthorizationHeader(options);


      var startDate = new Date();
      this.nodeLogger.AddLogWithTime("START REQUEST " + url);

      return this.http
        .get(url, options)
        .map(ApiService.extractData)
        .do(json => {

          var endDate = new Date();

          var timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
          var diffMs = Math.ceil(timeDiff);

          this.nodeLogger.AddLogWithTime("END REQUEST " + url + "(" + diffMs + ")");

          this.cache.set(url, json);
        })
        .catch((err: any) => this.handleError(err));
    }

  }

  /**
 * whatever domain/feature method name
 */
  getUniversalCached(url: string, options?: RequestOptionsArgs): Observable<any> {
    if (this.isBrowser && this.cache.has(url)) {

      let obs = Observable.of(this.cache.get(url));
      this.cache.clear(url);
      return obs;
    }

    options = this.createAuthorizationHeader(options);
    return this.http
      .get(url, options)
      .map(ApiService.extractData)
      .do(json => {
        if (!this.isBrowser) {
          this.cache.set(url, json);
        }
      })
      .catch((err: any) => this.handleError(err));
  }

  post(url, body?: any, options?: RequestOptionsArgs): Observable<any> {
    options = this.createAuthorizationHeader(options);
    return this.http
      .post(url, body, options)
      .map(ApiService.extractData)
      .catch((err: any) => this.handleError(err));
  }

  private createAuthorizationHeader(options: RequestOptionsArgs = {}) {
    //Token is read from cache and not cookie. 
    //Note: Before it was read form cookie and it was not containing the last token.
    //Because the set cookie is done on the response and the get cookie is done on the request.
    let cookieLang = this.cookie.get('CURRENT_LANG');
    if (cookieLang) {
      if (!options.headers) {
        options.headers = new Headers();
      }
      var LangToUse = this.getLongLangByShort(cookieLang);
      options.headers.append('Lang', LangToUse);
    }
    let token = this.cache.get('__ACCESS_TOKEN__');
    if (token) {
      if (!options.headers) {
        options.headers = new Headers();
      }
      options.headers.append('Authorization', `Bearer ${token}`);
    }
    return options;
  }

  getLongLangByShort(language): string {
    var lang = '';
    switch (language) {
      case 'it': lang = 'it-IT';
        break;
      case 'en': lang = 'en-GB';
        break;
      case 'al': lang = 'sq-AL';
        break;
      case 'de': lang = 'de-DE';
        break;
      case 'sl': lang = 'sl-SI';
        break;
      case 'hr': lang = 'hr-HR';
        break;
      case 'pt': lang = 'pt-PT';
        break;
      case 'es': lang = 'es-ES';
        break;
      case 'fr': lang = 'fr-FR';
        break;
      case 'pl': lang = 'pl-PL';
        break;
      case 'tr': lang = 'tr-TR';
        break;
    }
    return lang;
  }

  private static extractData(res: Response): { [key: string]: any } {
    if (res.status === responseStatuses.noContent) {
      return {};
    }

    let body = res.json();
    return body || {};
  }

  private handleError(err): Observable<any> {

    this.nodeLogger.AddLogWithTime("Error: " + err);

    let cookieToken = this.cookie.get('accessToken');
    let cacheToken = this.cache.get('__ACCESS_TOKEN__');

    if (!this.isBrowser) {
      return Observable.empty();
    }

    switch (err.status) {
      case 401:
        this.handleUnauthorized();
        break;
      default:
        break;
    }
    return Observable.throw(err);
  }

  private handleUnauthorized() {
    //If the token expires while using the application, the user is redirected to home page to get a new token and start navigation from there.
    if (this.isBrowser) {
      window.location.href = "/";
    }
  }

}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/api.service.ts